// Mayúscula inicial por palabra, conectores en minúscula (regla de pantallas,
// mismo criterio que ya usa Obras).
const CONECTORES = ['de', 'del', 'la', 'las', 'los', 'el', 'y', 'e', 'o', 'u', 'a', 'al', 'en', 'con', 'por', 'para', 'un', 'una'];

const toTitleCase = (texto) => {
  if (!texto) return texto;
  return String(texto)
    .toLowerCase()
    .split(' ')
    .map((palabra, i) => {
      if (i > 0 && CONECTORES.includes(palabra)) return palabra;
      return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    })
    .join(' ');
};

export default toTitleCase;
